<template>
  <notification :notification="notification">
    <template slot="title">
      您订阅的文章
      <router-link :to="{name: 'threads.show', params: {dynamic_id: notification.relation.dynamic_id}}">
        《{{ notification.relation.dynamic_title }}》
      </router-link>
      有新评论消息
    </template>
  </notification>
</template>

<script>
import Notification from './notification'

export default {
  components: { Notification },
  props: {
    notification: {
      type: Object,
      default: null
    }
  }
}
</script>
